import { Result, failure, success } from '../shared'
import { GridsProvider } from './grids.provider'
import { GridsServiceErrorCode, GridState, GridServerResponse } from './grids.types'

export class GridsService {
  constructor(private provider: GridsProvider) {}

  public async get(form: string, object?: string): Promise<Result<GridServerResponse>> {
    try {
      const { data } = await this.provider.get(form, object)
      return success(data)
    } catch (error) {
      return failure(GridsServiceErrorCode.GENERAL)
    }
  }

  public async save(form: string, object: string, gridStates: GridState[]): Promise<Result<undefined>> {
    try {
      await this.provider.save(form, object, JSON.stringify(gridStates))
      return success()
    } catch (error) {
      return failure(GridsServiceErrorCode.GENERAL)
    }
  }
}
